module.exports = __webpack_public_path__ + "files/bb524eed1f62b5376e9185822e43f365.svg";